import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCurrency } from '../../context/CurrencyContext';
import { useSocket } from '../../context/SocketContext';
import { productsApi } from '../../services/apiService';
import { API_BASE_URL } from '../../config/api';
import MobileBottomNav from '../../components/MobileBottomNav/MobileBottomNav';
import './MobileMyAlibabaPage.css';

const PAGE_SIZE = 20;

const FEATURES = [
  {
    id: 'favorites',
    label: 'Favorites',
    path: '/mobile/favorites',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    id: 'history',
    label: 'Browsing\nhistory',
    path: '/mobile/browsing-history',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    id: 'subscription',
    label: 'Subscription',
    path: '/membership-packages',
    isNew: true,
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    id: 'coupons',
    label: 'Coupons &\ncredit',
    path: '/mobile/coupons-credit',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
        <line x1="1" y1="10" x2="23" y2="10" />
      </svg>
    ),
  },
  {
    id: 'payment',
    label: 'Payment',
    path: '/mobile/cards-accounts',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="7" width="18" height="12" rx="2" />
        <path d="M7 7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" />
        <line x1="3" y1="12" x2="21" y2="12" />
      </svg>
    ),
  },
  {
    id: 'shipping',
    label: 'Shipping\naddresses',
    path: '/mobile/shipping-address',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
    ),
  },
  {
    id: 'inquiries',
    label: 'Inquiries',
    path: '/mobile/inquiries',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <path d="M12 8v6M10 10h4" strokeLinecap="round" />
        <path d="M10 14h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'rfq',
    label: 'Request for\nQuotation',
    path: '/mobile/request-quotation',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    id: 'tax',
    label: 'Tax\ninformation',
    path: '/mobile/tax-information',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="5" y="3" width="14" height="18" rx="2" />
        <path d="M9 8h6M9 11h6M9 14h4" strokeLinecap="round" />
        <path d="M10 18h4l-1-2h-2l-1 2z" fill="currentColor" stroke="none" opacity="0.35" />
      </svg>
    ),
  },
  {
    id: 'membership',
    label: 'Membership',
    path: '/membership-packages',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="4" y="12" width="16" height="9" rx="1.5" />
        <rect x="6" y="7" width="12" height="7" rx="1.5" />
        <rect x="8" y="3" width="8" height="6" rx="1.5" />
      </svg>
    ),
  },
  {
    id: 'start_selling',
    label: 'Start\nselling',
    path: '/documents-submit',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 3c-2 0-3 2-2 4l1 14h2l1-14c1-2 0-4-2-4z" strokeLinejoin="round" />
        <path d="M10 7h4M9 11h6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'help',
    label: 'Help\nCenter',
    path: '/mobile/help-centre',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4" strokeLinecap="round" />
        <line x1="12" y1="17" x2="12.01" y2="17" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'legal',
    label: 'Legal\nnotice',
    path: '/privacy-policy',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M12 3v2M7 8h10M6 8l-1 10h14l-1-10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 12h6M8 18h8" strokeLinecap="round" />
        <circle cx="9" cy="15" r="2" />
        <circle cx="15" cy="15" r="2" />
      </svg>
    ),
  },
  {
    id: 'settings',
    label: 'Settings &\nadmin',
    path: '/settings',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    ),
  },
];

const INTEREST_TABS = ['All', 'Sports & Entertainment', 'Consumer Electronics', 'Electronics', 'Home & Garden'];

const MobileMyAlibabaPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { formatPrice, formatPriceRange } = useCurrency();

  const [activeTab, setActiveTab] = useState('All');
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [orders, setOrders] = useState([]);
  const { on, off } = useSocket();
  const observerRef = useRef(null);
  const sentinelRef = useRef(null);

  const userName = user?.name || user?.companyName || user?.email?.split('@')[0] || 'Guest';
  const userInitial = userName.charAt(0).toUpperCase();

  // Load orders
  const fetchOrders = useCallback(async (silent = false) => {
    if (!user?.id) return;
    if (!silent) setLoadingOrders(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_BASE_URL}/orders?userId=${user.id}`, {
        headers: { ...(token && { Authorization: `Bearer ${token}` }) },
      });
      if (res.ok) {
        const data = await res.json();
        setOrders(data.orders || data || []);
      }
    } catch (_) {
      setOrders([]);
    } finally {
      if (!silent) setLoadingOrders(false);
    }
  }, [user?.id]);

  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  useEffect(() => {
    if (!on || !off || !user?.id) return;
    const handleOrderChange = () => fetchOrders(true);
    on('order_updated', handleOrderChange);
    on('order_created', handleOrderChange);
    return () => {
      off('order_updated', handleOrderChange);
      off('order_created', handleOrderChange);
    };
  }, [on, off, user?.id, fetchOrders]);

  // Load products (paginated)
  const loadMore = useCallback(async () => {
    if (loadingProducts || !hasMore) return;
    setLoadingProducts(true);
    try {
      const res = await productsApi.getAll({ limit: PAGE_SIZE, page });
      const list = Array.isArray(res) ? res : (res?.products || res?.data || []);
      if (list.length < PAGE_SIZE) setHasMore(false);
      setProducts((prev) => {
        const ids = new Set(prev.map((p) => p.id));
        return [...prev, ...list.filter((p) => !ids.has(p.id))];
      });
      setPage((p) => p + 1);
    } catch {
      setHasMore(false);
    } finally {
      setLoadingProducts(false);
    }
  }, [loadingProducts, hasMore, page]);

  // Initial load
  useEffect(() => {
    loadMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Infinite scroll sentinel
  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();
    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loadingProducts) {
          loadMore();
        }
      },
      { threshold: 0.1 }
    );
    if (sentinelRef.current) observerRef.current.observe(sentinelRef.current);
    return () => observerRef.current?.disconnect();
  }, [hasMore, loadingProducts, loadMore]);

  const getProductImage = (p) => {
    if (p?.image) return p.image;
    if (p?.images?.length) return p.images[0];
    return null;
  };

  const getPrice = (p) => {
    const min = p?.priceMin ?? p?.price ?? null;
    const max = p?.priceMax ?? null;
    if (min !== null && max !== null && Number(min) !== Number(max)) return formatPriceRange(min, max);
    if (min !== null) return formatPrice(min);
    return null;
  };

  const filteredProducts = activeTab === 'All'
    ? products
    : products.filter((p) => (p.category || '').toLowerCase().includes(activeTab.toLowerCase()));

  return (
    <div className="mma-page">
      {/* ── Header ── */}
      <div className="mma-header">
        <div className="mma-header-left" onClick={() => navigate('/mobile/profile')}>
          <div className="mma-avatar">
            {user?.avatar || user?.logo
              ? <img src={user.avatar || user.logo} alt={userName} />
              : <span>{userInitial}</span>}
          </div>
          <div className="mma-user-info">
            <span className="mma-user-name">{userName}</span>
            <svg className="mma-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
          <div className="mma-deliver">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            <span>Deliver to IN</span>
          </div>
        </div>
        <div className="mma-header-right">
          <button type="button" className="mma-icon-btn" aria-label="Support" onClick={() => navigate('/my-support')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.88a16 16 0 0 0 6 6l.95-.95a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z" />
            </svg>
          </button>
          <button type="button" className="mma-icon-btn" aria-label="Scan" onClick={() => navigate('/mobile/worldwide')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M3 7V5a2 2 0 0 1 2-2h2" /><path d="M17 3h2a2 2 0 0 1 2 2v2" />
              <path d="M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 21H5a2 2 0 0 1-2-2v-2" />
              <rect x="7" y="7" width="10" height="10" />
            </svg>
          </button>
          <button className="mma-icon-btn" aria-label="Settings" onClick={() => navigate('/settings')}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </button>
        </div>
      </div>

      {/* ── Features ── */}
      <div className="mma-section mma-features-section">
        <div className="mma-section-hdr">
          <span className="mma-section-title">Features</span>
          <button type="button" className="mma-section-arrow" aria-label="More features" onClick={() => navigate('/all-categories')}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>
        <div className="mma-features-row">
          {FEATURES.map((f) => (
            <button type="button" key={f.id} className="mma-feature-item" onClick={() => navigate(f.path)}>
              <div className="mma-feature-icon-wrap">
                {f.icon}
                {f.isNew && <span className="mma-feature-new">New</span>}
              </div>
              <span className="mma-feature-label">{f.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* ── AI Mode Banner ── */}
      <div className="mma-ai-banner" onClick={() => navigate('/')}>
        <span className="mma-ai-text">Try <strong className="mma-ai-highlight">AI Mode</strong> for free and subscribe for more</span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
          <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
        </svg>
      </div>

      {/* ── My Orders ── */}
      <div className="mma-section">
        <div className="mma-section-hdr">
          <span className="mma-section-title">My orders</span>
          <button className="mma-section-arrow" onClick={() => navigate('/mobile/orders')}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>
        <div className="mma-orders-row">
          {[
            { label: 'Unpaid', icon: '💳' },
            { label: 'Processing', icon: '⚙️' },
            { label: 'Shipped', icon: '🚚' },
            { label: 'Review', icon: '⭐' },
            { label: 'Dispute', icon: '🔔' },
          ].map((s) => (
            <button key={s.label} className="mma-order-status" onClick={() => navigate('/mobile/orders')}>
              <span className="mma-order-icon">{s.icon}</span>
              <span className="mma-order-label">{s.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* ── Promo Cards ── */}
      <div className="mma-promo-row">
        <div className="mma-promo-card mma-promo-card--earn" onClick={() => navigate('/mobile/coupons-credit')} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && navigate('/mobile/coupons-credit')}>
          <div>
            <p className="mma-promo-title">Share &amp; Earn</p>
            <p className="mma-promo-sub">Get coupons</p>
          </div>
          <img className="mma-promo-img" src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=120" alt="Share and earn" />
        </div>
        <div className="mma-promo-card mma-promo-card--source" onClick={() => navigate('/products')} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && navigate('/products')}>
          <div>
            <p className="mma-promo-title">Source repeat buyers' favorite picks</p>
            <p className="mma-promo-sub">Explore now</p>
          </div>
          <img className="mma-promo-img" src="https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=120" alt="Source picks" />
        </div>
      </div>

      {/* ── List Items ── */}
      <div className="mma-list-section">
        <button className="mma-list-item" onClick={() => navigate('/')}>
          <div className="mma-list-icon-wrap mma-list-icon--dark">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <span className="mma-list-text">FREE trial: Accio AI sourcing agent</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
        <button className="mma-list-item" onClick={() => navigate('/profile')}>
          <div className="mma-list-icon-wrap mma-list-icon--outline">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
            </svg>
          </div>
          <span className="mma-list-text">Start selling on Alibaba.com</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      {/* ── Inspired by your interests ── */}
      <div className="mma-interests-section">
        <div className="mma-interests-hdr">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <h2 className="mma-interests-title">Inspired by your interests</h2>
        </div>
        <div className="mma-tabs-scroll">
          {INTEREST_TABS.map((tab) => (
            <button
              key={tab}
              className={`mma-tab ${activeTab === tab ? 'is-active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="mma-grid">
          {filteredProducts.map((product, idx) => {
            const img = getProductImage(product);
            const price = getPrice(product);
            const seller = product.seller || {};
            return (
              <div key={product.id} className="mma-grid-card" onClick={() => navigate(`/mobile/product/${product.id}`)}>
                <div className="mma-grid-img">
                  {img
                    ? <img src={img} alt={product.name} loading="lazy" />
                    : <div className="mma-grid-img-placeholder" />}
                  <button
                    className="mma-grid-cam"
                    aria-label="Search by image"
                    onClick={(e) => { e.stopPropagation(); }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                      <circle cx="12" cy="13" r="4" />
                    </svg>
                  </button>
                </div>
                <div className="mma-grid-info">
                  <p className="mma-grid-name">{product.name}</p>
                  {price && (
                    <p className="mma-grid-price">
                      {price}
                      {product.moq && <span className="mma-grid-moq"> MOQ: {product.moq}</span>}
                    </p>
                  )}
                  <p className="mma-grid-meta">
                    {seller.yearsActive ? `${seller.yearsActive} yrs · ` : ''}
                    {seller.country || 'CN'}
                  </p>
                  {(product.soldCount || product.sold) && (
                    <p className="mma-grid-sold">{(product.soldCount || product.sold).toLocaleString()} sold</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Infinite scroll sentinel */}
        <div ref={sentinelRef} style={{ height: 1 }} />
        {loadingProducts && (
          <div className="mma-loading-more">
            <span className="mma-spinner" />
          </div>
        )}
        {!hasMore && products.length > 0 && (
          <p className="mma-no-more">You've seen all products</p>
        )}
      </div>

      {/* ── Bottom Nav ── */}
      <MobileBottomNav />
    </div>
  );
};

export default MobileMyAlibabaPage;
